module.exports = __webpack_public_path__ + "img/lg_memorial.38b92bd8.png";